import { useTranslation } from 'next-i18next';

import styles from '@/shared/components/molecules/JobInstanceCard/JobInstanceCard.module.css';

import { getTeamHeaderCardData } from '@/modules/workingDay/components/Details/TeamList/logic';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Typography } from '@/shared/components/atoms';

import Person from '~/images/shared/Person.svg';

const TeamHeader: React.FC<{
  team: IWorkingDay.IJobInstanceSupplier;
  productivityMeasurementUnit: string;
}> = ({ team, productivityMeasurementUnit }) => {
  const { t } = useTranslation('common');
  const cardData = getTeamHeaderCardData(team, t, productivityMeasurementUnit);

  return (
    <div className='flex w-full items-center gap-2'>
      <div className={styles['imageWrapper']}>
        <span className='text-24'>
          <Person />
        </span>
      </div>
      <div className='flex w-11/12 items-center justify-between gap-2 overflow-x-auto overflow-y-hidden'>
        {Object.entries(cardData).map(([key, value]) => (
          <div key={key} className='flex w-1/5 flex-col gap-1'>
            <div className='w-fit text-center'>
              <Typography variant='body2' className='text-text-600'>
                {t(key)}
              </Typography>
              <Typography variant='subtitle2' className='text-text-default'>
                {value || '-'}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TeamHeader;
